<template>
  <tbody>
  <tr :class="[{more_info: $_updateActionAllowed, open: isOpen }]" @click="toggleMoreInfo()">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td><td :data-th="'Název štítku' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Počet operátorů' | translate">
      <span v-if="entity.operator_count > 0" class="dotted">
          {{ entity.operator_count }}
          <span class="help_popup help_popup--no-wrap">
              {{entity.operator_names.join(', ')}}
          </span>
      </span>
      <span v-else>{{ entity.operator_count }}</span>
      </td>
    <td :data-th="'Vytvořeno' | translate" v-html="$_date_format(entity.date_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteOperatorTag">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  <tr :class="['more_info_content', { open: isOpen }]">
    <td></td>
    <td></td>
    <td class="first_data">
      <text-input
          :id="'tag-name-'+entity.id"
          v-model="entity.name"
          :required="true"
          ref="operatortagnameref">
        <translate class="translate">Název štítku operátora</translate>
      </text-input>
    </td>
    <td></td>
    <td><p>
      <input
          class="btn"
          type="submit"
          :value="'Uložit' | translate"
          @click.stop.prevent="emitUpdateOperatorTag">
    </p></td>
    <td class="no_padding"></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "OperatorTagsRow",
  mixins: [rowActions],
  data: function () {
    return {
      isOpen: false
    }
  },
  props: {
    entity: Object,
  },
  methods: {
    toggleMoreInfo() {
      if(this.$_updateActionAllowed) {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          this.resetInput('operatortagnameref')
        }
      }
    },
    resetInput(ref) {
      this.$refs[ref].setForcedInvalid(false)
      this.$refs[ref].setTouched(false)
    },
    hideMoreInfo() {
      this.isOpen = false
    },
    emitDeleteOperatorTag() {
      this.$emit('deleteOperatorTag', String(this.entity.id))
    },
    emitUpdateOperatorTag() {
      let data = {
        id: this.entity.id,
        params: {name: this.entity.name}
      }
      this.$emit('updateOperatorTag', data)
      this.hideMoreInfo()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operatorTags/OperatorTagRow.vue